var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{class:_vm.formGroupClass},[_c('label',[_vm._t("default")],2),_vm._v(" "),_c('b-form-select',_vm._b({class:_vm.addClass,attrs:{"options":_vm.items,"value":_vm.value,"plain":true},on:{"input":function($event){return _vm.$emit('input', $event)}}},'b-form-select',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b819004","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SelectBox.vue
// module id = null
// module chunks = 